import { dateFormat, dateRelative } from '@/utils/date'

export default (app) => {
  app.config.globalProperties.$filters = {
    dateFormat,
    dateRelative
  }
}
